// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picker-faturamento .v-btn--active {\n  color: blue !important;\n}\n\n/* Add your component styles here */", ""]);
// Exports
module.exports = exports;
